import { Link } from "react-router-dom";
import { useT } from "@/i18n/LanguageContext";
import { pickLang } from "@/data/stoicosCards";
import { STOIC_TRAINING, TRAINING_SECTION, TRAINING_LABELS } from "@/data/stoicTraining";

export function StoicTrainingSection() {
  const { lang } = useT();
  const labels = TRAINING_LABELS[lang] || TRAINING_LABELS.en;
  return (
    <section className="mt-20 md:mt-24" aria-labelledby="stoic-training-heading" data-testid="stoic-training-section">
      <h2 id="stoic-training-heading" className="font-serif text-2xl md:text-3xl text-bone tracking-tight" data-testid="stoic-training-heading">
        {pickLang(TRAINING_SECTION.label, lang)}
      </h2>
      <p className="mt-4 max-w-2xl text-bone/75 font-reading text-base md:text-lg leading-[1.85]">
        {pickLang(TRAINING_SECTION.blurb, lang)}
      </p>
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
        {STOIC_TRAINING.map((c) => (
          <Link
            key={c.slug}
            to={`/stoic-training/${c.slug}`}
            data-testid={`training-card-${c.slug}`}
            className="group block border border-white/8 bg-ink-elevated/40 hover:border-gold/40 transition-colors"
          >
            <img
              src={`/cards/${c.file}`}
              alt={`${pickLang(c.partLabel, lang)} — ${pickLang(c.title, lang)} · Ed Korporaal, Stoic Wisdom`}
              width={c.w}
              height={c.h}
              loading="lazy"
              className="w-full h-auto"
            />
            <div className="p-5 md:p-6">
              <p className="text-[10px] tracking-[0.28em] uppercase text-gold/90">
                {labels.eyebrow} · {pickLang(c.partLabel, lang)}
              </p>
              <h3 className="mt-2 font-serif text-xl text-bone tracking-tight group-hover:text-gold transition-colors">
                {pickLang(c.title, lang)}
              </h3>
              <p className="mt-2 text-bone/70 font-reading text-sm leading-[1.7]">
                {pickLang(c.tagline, lang)}
              </p>
              <p className="mt-4 text-[11px] tracking-[0.22em] uppercase text-gold/80 group-hover:text-gold transition-colors">
                {labels.open} →
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
